/* eslint-disable no-unused-vars */
import Vue from "vue";
import Vuex from "vuex";
import router from "../router";
import axios from "axios";
import jwt_decode from "jwt-decode";
import {ObjectToQuery} from "@/plugins/helper";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    barColor: "rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.2)",
    barImage: "",
    drawer: localStorage.getItem("drawer") == null ?
        true : localStorage.getItem("drawer") == "true",
    drawerMessage: null,
    school: {},
    schools: {},
    alerts: {},
    UploaderUrl: "",
    idToken: localStorage.getItem("token"),
    overlay: false,
    userDirectorates: null,
    userGovernorates: null,
    years: null,
    servers: null,
    types: null,
    classes: null,
  },
  mutations: {
    setCurrentPage(state, data) {
      state.schools.current_page = data;
    },
    toggleAlert(state, name) {
      let id = state.alerts.indexOf(name);
      if (id !== -1) {
        state.alerts.splice(id, 1);
      } else {
        state.alerts.push(name);
      }
    },
    setSchools(state, data) {
      state.schools = data;
    },
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload;
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload;
      localStorage.setItem("drawer", payload);
    },
    SET_SCHOOL(state, payload) {
      state.school = payload;
      //localStorage.setItem("drawer", payload);
    },
    SET_DRAWER_Message(state, payload) {
      state.drawerMessage = payload;
    },
    SET_SCRIM(state, payload) {
      state.barColor = payload;
    },
    SET_UPLOADER(state, payload) {
      state.UploaderUrl = payload;
    },
    overlay(state, overlay) {
      state.overlay = overlay;
    },
    authUser(state, userData) {
      state.idToken = userData.token;
      state.expiration = userData.expiration;
    },
  },
  getters: {
    isLoading(state) {
      return state.overlay;
    },
    isInRole: (state) => (role) => {
      var is = jwt_decode(state.idToken).roles.some((s) => s == role);
      return is;
    },
    userName() {
      return JSON.parse(localStorage.getItem("userData")).name;
    },
  },
  actions: {
    async GetUserAlerts({state, dispatch}, skipTimer = null) {
      try {
        if (state.idToken) {
          const response = await axios.get("GetUserAlerts", {noToast: true});
          state.alerts = response.data;
        }
      } finally {
        if (!skipTimer) {
          setTimeout(() => {
            dispatch('GetUserAlerts');
          }, 300000);
        }
      }
    },
    async GetUserDirectorates({state}) {
      if (!state.userDirectorates) {
        const response = await axios.get("GetUserDirectorates", {noToast: true});
        state.userDirectorates = response.data.data;
      }
      return state.userDirectorates;
    },
    async GetUserGovernorates({state}) {
      if (!state.userGovernorates) {
        const response = await axios.get("GetUserGovernorates", {noToast: true});
        state.userGovernorates = response.data.data;
      }
      return state.userGovernorates;
    },
    async GetYears({state}) {

      const response = await axios.get("GetYears", {noToast: true});
      state.years = response.data.data;

      return state.years;
    },
    async GetServers({state}) {
      if (!state.servers) {
        const response = await axios.get("servers/?onlyAllow=1", {noToast: true});
        state.servers = response.data.data;
      }
      return state.servers;
    },
    async GetSchoolsTypes({state}) {
      if (!state.types) {
        const response = await axios.get("GetSchoolsTypes", {noToast: true});
        state.types = response.data.data;
      }
      return state.types;
    },
    async GetClasses({state}) {
      if (!state.classes) {
        const response = await axios.get("advertisements/classes", {noToast: true});
        state.classes = response.data.data;
      }
      return state.classes;
    },
    async getSchools({commit}, data) {
      // Build params object and JSON-encode arrays/objects as required
      const params = {
        page_size: 50,
        page: data.pageNumber,
      };

      if (data.name != null && data.name !== "") params.name = data.name;
      if (data.domain_scid != null && data.domain_scid !== "") params.domain_scid = data.domain_scid;
      if (data.free != null) params.free = data.free;
      if (data.active != null) params.active = data.active;
      if (data.owner != null) params.owner = data.owner;
      if (data.createdAt != null) params.createdAt = data.createdAt;
      if (data.year_id != null) params.year_id = data.year_id;
      if (data.financial_status_student != null) params.financial_status_student = data.financial_status_student;
      if (data.financial_status_teacher != null) params.financial_status_teacher = data.financial_status_teacher;
      if (data.financial_status_driver != null) params.financial_status_driver = data.financial_status_driver;

      if (data.directorate_ids.length)
        params.directorate_ids = data.directorate_ids;
      if (data.governorate_ids.length)
        params.governorate_ids = data.governorate_ids;
      if (data.school_types.length)
        params.school_types = data.school_types;

      if (data.deleted) params.deleted = true;
      if (data.lessStudents) params.lessStudents = true;

      if (data.agency_id !== null && data.agency_id !== undefined) params.agency_id = data.agency_id;

      if (data.financeFilter) params.financeFilter = {...data.financeFilter};

      if (data.min_created_student) params.min_created_student = data.min_created_student;
      if (data.has_min_created_student) params.has_min_created_student = data.has_min_created_student;
      if (data.notificationUsageState) params.notification_usage = data.notificationUsageState;
        if (data.gift_type != null && data.gift_type !== "") params.gift_type = data.gift_type;

      const res = await axios.get("GetSchools", { params, noToast: true });
      commit("setSchools", res.data.data);
      return res.data.data;
    },

    async exportSchools({commit}, data) {
      const params = {};
      if (data.name != null && data.name !== "") params.name = data.name;
      if (data.domain_scid != null && data.domain_scid !== "") params.domain_scid = data.domain_scid;
      if (data.free != null) params.free = data.free;
      if (data.active != null) params.active = data.active;
      if (data.owner != null) params.owner = data.owner;
      if (data.createdAt != null) params.createdAt = data.createdAt;
      if (data.year_id != null) params.year_id = data.year_id;
      if (data.financial_status_student != null) params.financial_status_student = data.financial_status_student;
      if (data.financial_status_teacher != null) params.financial_status_teacher = data.financial_status_teacher;
      if (data.financial_status_driver != null) params.financial_status_driver = data.financial_status_driver;

      if (data.directorate_ids.length)
        params.directorate_ids = data.directorate_ids;
      if (data.governorate_ids.length)
        params.governorate_ids = data.governorate_ids;
      if (data.school_types.length)
        params.school_types = data.school_types;

      if (data.deleted) params.deleted = true;
      if (data.lessStudents) params.lessStudents = true;

      if (data.agency_id !== null && data.agency_id !== undefined) params.agency_id = data.agency_id;

      if (data.financeFilter) params.financeFilter = {...data.financeFilter};

      if (data.min_created_student) params.min_created_student = data.min_created_student;
      if (data.has_min_created_student) params.has_min_created_student = data.has_min_created_student;
      if (data.notificationUsageState) params.notification_usage = data.notificationUsageState;
      if (data.gift_type != null && data.gift_type !== "") params.gift_type = data.gift_type;
      const getFileName = (fileBlob, defaultFileName) => {
        const contentDisposition = (fileBlob).headers['content-disposition']

        if (contentDisposition) {
          const fileNameIdentifier = 'filename='
          const filenamePosition = contentDisposition.indexOf(fileNameIdentifier)

          if (~filenamePosition)
            return contentDisposition.slice(filenamePosition + fileNameIdentifier.length, contentDisposition.length).replace(/"/g, '')
        }

        return defaultFileName
      }
      const downloadFile = (fileBlob, fileName) => {
        const url = URL.createObjectURL(new Blob([fileBlob], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}))
        const link = document.createElement('a')

        link.href = url
        link.setAttribute('download', `${fileName}`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        link.style.display = 'none'
        window.URL.revokeObjectURL(url)
      }

      const fileBlob = await axios.get("exportSchools", {
        params: params,
        responseType: 'blob',
        noToast: true,
        failureToast: true
      });
      const fileName = getFileName(fileBlob, 'export.xlsx')
      downloadFile(fileBlob.data, fileName)
    },
    overlay({commit}, overlay) {
      commit("overlay", overlay);
    },
    login({commit}, data) {
      localStorage.setItem("token", data.token);
      localStorage.setItem("userData", JSON.stringify(data.userData));
      commit("authUser", {
        token: data.token,
        expiration: data.expiration,
      });
      axios.defaults.headers.get["Authorization"] =
          "Bearer " + data.token;
      router.push({
        name: "Dashboard",
      });
    },
    logout({commit}) {
      if (this.$vuetify) {
        localStorage.setItem("dark", this.$vuetify.theme.dark);
        this.$vuetify.rtl = localStorage.getItem("lang") == "ar" ? true : false;
      }
      if (this.$i18n) {
        this.$i18n.locale = this.$i18n.locale == "ar" ? "ar" : "en";
        localStorage.setItem("lang", this.$i18n.locale);
      }

      localStorage.removeItem("token");
      localStorage.removeItem("userData");

      axios.defaults.headers.get["Authorization"] = null;
    },
  },
});
